export default {"src":"/_next/static/media/idCard.03c471f2.svg","height":33,"width":41,"blurWidth":0,"blurHeight":0};